import buildUrl from "./buildUrl";
const url = buildUrl('/file/uploadfile')
export default url;